import { combineReducers } from "redux";
import auth from "./auth";
import forum from './formReducer';
import snackbar from "./snackbar"

export default combineReducers({ auth, forum, snackbar });